function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "16"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_82",
  "data-name": "Path 82",
  d: "M3 4h18v2H3zm0 7h18v2H3zm0 7h18v2H3z",
  transform: "translate(-3 -4)",
  fill: "#f7ce50"
})));